import _ from "lodash";

window._ = _;

export default _;
